// extracted by mini-css-extract-plugin
module.exports = {"credit_symbol":"CreditSymbol_credit_symbol__2h4Ki"};